module.exports = new __parcel__URL__("rabbit.b4ce71c1.svg").toString();